import { Warning } from "@mui/icons-material"
import { Fade, Grid, Icon, Link, Typography } from "@mui/material"
import { Intervention, Maybe } from "../../generated/graphql"
import { DeepPartial } from "../../types/types"
import styles from './InterventionDuplicateWarning.module.scss'

interface InterventionDuplicateWarningProps {
    interventions?: Maybe<DeepPartial<Intervention>[]>
}

export default function InterventionDuplicateWarning(props: InterventionDuplicateWarningProps) {
    const { interventions } = props

    if (!interventions?.length) {
        return null
    }

    const count = interventions.length
    const isPlural = count > 1

    const links = interventions?.map((intervention: any, index: number) => (
        <span key={intervention.id}>
            {index > 0 && (index === count - 1 ? " e " : ", ")}
            <Link
                href={`/intervention/${intervention.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.Link}
            >
                {intervention.name}
            </Link>
        </span>
    ))

    return (
        <Fade in={!!interventions?.length}>
            <Grid className={styles.Wrapper}>

                <Typography variant="h4" color="secondary">
                    <Grid container alignItems="center" className={styles.Header}>
                        <Icon><Warning /></Icon> <span className={styles.Title}>Atenção!</span>
                    </Grid>
                </Typography>

                <Typography variant="body1" color="text" gutterBottom>
                    Existe{isPlural ? "m" : ""} {count} intervenç{isPlural ? "ões" : "ão"} pendente{isPlural ? "s" : ""} para a mesma permissão e semana.
                </Typography>
                <Typography variant="body1" color="text">
                    Antes de prosseguir verifique {isPlural ? "as intervenções" : "a intervenção"} {links}.
                </Typography>
            </Grid >
        </Fade>
    )
}
